var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSyncwarn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B98900",
  d: "M14 2a12 12 0 1 1 0 24 12 12 0 0 1 0-24m0 15.75A1.125 1.125 0 1 0 14 20a1.125 1.125 0 0 0 0-2.25M14 8a.75.75 0 0 0-.738.615l-.012.135v6.75l.012.135a.75.75 0 0 0 1.476 0l.012-.135V8.75l-.012-.135A.75.75 0 0 0 14 8"
})));
export { SvgSyncwarn as ReactComponent };
export default __webpack_public_path__ + "static/media/sync.warn.44ac2af1.svg";